/**
 * Theme owned "Buy now" button.
 *
 * Shopify's dynamic checkout button ({{ form | payment_button }}) renders whichever
 * accelerated wallet the shopper's browser supports (Shop Pay, Apple Pay, Google Pay)
 * and only falls back to the unbranded "Buy now" button when no wallet is available.
 * This element is used where the plain "Buy now" configuration must always be shown:
 * it adds the current selection to the cart, then sends the shopper to the checkout.
 */
if (!window.customElements.get('buy-now-button')) {
  window.customElements.define(
    'buy-now-button',
    class BuyNowButton extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();

        this.addEventListener('click', (event) => this.buyNow(event), {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      async buyNow(event) {
        const button = event.target.closest('button');
        const form = document.forms[this.getAttribute('form')] || this.closest('form');

        if (button == null || form == null || button.getAttribute('aria-busy') === 'true') {
          return;
        }

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        button.setAttribute('aria-busy', 'true');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        let response;

        try {
          response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: new FormData(form),
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest', // Needed for Shopify to check inventory
            },
          });
        } catch {
          this.reset(button);
          return;
        }

        if (response.ok) {
          window.location.href = `${Shopify.routes.root}checkout`;
          return;
        }

        this.reset(button);

        const responseJson = await response.json();

        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              error: responseJson['description'],
            },
          })
        );

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }

      reset(button) {
        button.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }
  );
}
